'use client';

import {
	Stack, SimpleGrid, Text,
} from '@chakra-ui/react';

import { images } from '@/constants/images';
import {
	JobCardFeatured, useRemoveJobHandler, useSaveJobHandler,
} from '@/modules/job';

const MOCKED = {
	id: '',

	companyName: 'Google LLC',
	detailUrl:   '/jobs/new',
	image:       images.mocked.hiring,
	isSaved:     false,
	location:    'Bangkok, Thailand',
	salary:      '฿80,000 - ฿120,000',
	title:       'Senior Product Designer',
};

export const PopularJobListScreen = () => {
	const saveJob = useSaveJobHandler();
	const removeJob = useRemoveJobHandler();

	return (
		<Stack gap="lg">
			<Text textAlign="center" textStyle="h1">
				Popular Jobs
			</Text>
			<SimpleGrid columns={4} gap="sm">
				{Array.from({ length: 12 }).map((_, index) => (
					<JobCardFeatured
						job={MOCKED}
						key={`popular-job-${index}`}
						onSelect={() => saveJob.execute(MOCKED.id)}
						onUnselect={() => removeJob.execute(MOCKED.id)}
					/>
				))}
			</SimpleGrid>
		</Stack>
	);
};
